import { Grid, Typography } from "@mui/material";
import React from "react";
import { CompanyTitledPage } from "../../TitledPage";

export default function DeliveryNote() {
  return (
    <CompanyTitledPage title="納品書" hideCurrentTime>
      <Grid container marginTop={2} marginBottom={2}>
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <Typography>納品書</Typography>
        </Grid>
      </Grid>
    </CompanyTitledPage>
  );
}
